// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightLanding-cls1_a55","cls2":"CiterightLanding-cls2_ioK CiterightLanding-cls1_a55"};